// extracted by mini-css-extract-plugin
module.exports = {"graphic-list":"GraphicList_graphic-list__7p9p8","graphic-list-two-across":"GraphicList_graphic-list-two-across__ouJ73"};